import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { selectPage } from './selectors'
import { setProgress as setNavigationProgress } from '@brainstud/react-tbl/features/navigation/store/actions'

const withPage = Component => props => {
  const { dispatch, staticContext, ...rest } = props

  return <Component {...rest} />
}

const mapProps = (state, props) => {
  const user = state.account.user
  const page = selectPage(state, props)

  return { user, page }
}

const mapActions = (dispatch) => {
  return {
    setNavigationProgress: params => dispatch(setNavigationProgress(params)),
  }
}

export default compose(
  connect(mapProps, mapActions),
  withApp,
  withPage,
)

// import React from 'react'
// import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
// import { connect } from 'react-redux'
// import { Redirect } from 'react-router-dom'
// import { withApp, scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
// import { AppView, AppContainer, AppHeader, AppContent, AppLogo } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
// import { Animation, Page, PageHeader } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
// import { Pages } from 'content/pages'
// import { bindActionCreators } from 'redux'
// import * as accountActions from '@brainstud/react-tbl/themes/pgw/v1/store/actions/accountActions'
// import { withPage } from '@brainstud/react-tbl/themes/pgw/v1/containers'

// export default withApp(connect(
//   (state, props) => ({
//     user: state.account.user,
//     progress: state.account.progress,
//     pages: Object.values(state.pages.list.byId),
//     navigation: Object.values(state.navigation.list.byId),
//   }),
//   (dispatch) => ({
//     accountActions: bindActionCreators(accountActions, dispatch)
//   })
// )(PageView))
